import { IPavementData } from '../fabrication-mockups/types';

// Action Types
export enum Types {
  LOAD_FABRICATION_PROJECTS = 'projects/LOAD_FABRICATION_PROJECTS',
  LOAD_FABRICATION_PROJECTS_SUCCESS = 'projects/LOAD_FABRICATION_PROJECTS_SUCCESS',
  LOAD_FABRICATION_PROJECTS_FAILURE = 'projects/LOAD_FABRICATION_PROJECTS_FAILURE',

  SET_NEED_TO_REFRESH_PROJECTS = 'projects/SET_NEED_TO_REFRESH_PROJECTS'
}

export enum EProjectStructure {
  BEAM_PROJECT = 'Projeto de viga',
  SLAB_PROJECT = 'Projeto de laje',
  PILLAR_PROJECT = 'Projeto de pilar',
  FOUNDATION_PROJECT = 'Projeto de fundação',
  STAIRS_PROJECT = 'Projeto de escada',
  WALL_PROJECT = 'Projeto de parede',
  OTHER = 'Outro'
}

export enum EProjectRevisionStatus {
  ALL = 'Todos',
  CURRENT_REVISION = 'Revisão atual',
  OLD_REVISION = 'Revisão antiga'
}

export interface IFabricationProject {
  id: number;
  contractNumber: string;
  fileName: string;
  structures: IStructuresData[];
  pavements: IPavementData[];
  creationDate: string;
  createdBy: string;
  revision?: string;
  mockupId?: number;
  mockupName?: string;
  revisionDateTime?: string;
  nextRevisionId?: number;
  revisionStatus: EProjectRevisionStatus;
  hasOrders: boolean;
}

export interface IStructuresData {
  id: number;
  name: EProjectStructure | string;
}

export interface IFabricationProjectResponse {
  projects?: IFabricationProject[];
}

export interface IFabricationProjectsState extends IFabricationProjectResponse {
  contractNumber?: string;
  loading: boolean;
  error: boolean;
  errorMessage?: string;
  needToRefreshProjects: boolean;
}
